module.exports = __webpack_public_path__ + "static/media/voya-logo.40d6c18c.svg";